import dmi from './utils/deep-merge-inmutable';
import base from './base';
export default dmi(base, {
    message: {
        publishDocuments: {
            configIndivualPublish: {
                inputCuil: {
                    label: "Identificador",
                    question: "¿Cuál es el Identificador del colaborador?",
                    description: "Ingresa el Identificador del colaborador al que quieres enviarle un documento"
                },
            }
        },
        certificates: {
            newCertificate: {
                personalInfo: {
                    dni: "DNI",
                },
                dni: "DNI"
            }
        }
    }
})